import { macroSettings, macroParameters } from './shared.js';

export default {
  label: 'Focal Length vs. Wavelength', group: 'system',
  description: 'Effective focal length across the wavelength band.',
  settingsSchema: macroSettings,
  parameters: macroParameters,
  coverage: 'The plot needs Listing set to Yes. Wavelengths where CODE V reports no value are left blank.',
} as const;
